import { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { toast } from "sonner";
import { X } from "@phosphor-icons/react";
import { api, formatApiErrorDetail } from "../../lib/api";

export function ConvertVisitorModal({ visitor, category, onClose, onConverted }) {
  const [reps, setReps] = useState([]);
  const [name, setName] = useState(visitor.name || "");
  const [email, setEmail] = useState(visitor.email || "");
  const [phone, setPhone] = useState(visitor.phone || "");
  const [repId, setRepId] = useState("");
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    api.get("/admin/website-visitors/reps").then(({ data }) => setReps(data)).catch(() => setReps([]));
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      const { data } = await api.post(`/admin/website-visitors/${visitor.id}/convert`, {
        category, name: name.trim(), email: email.trim() || null, phone: phone.trim() || null,
        rep_id: repId || null,
      });
      toast.success("Converted to a real lead");
      onConverted(data.lead_id);
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail));
    } finally {
      setSaving(false);
    }
  };

  return createPortal(
    <div className="fixed inset-0 z-[9999] bg-black/90 flex items-center justify-center p-4" data-testid="convert-visitor-modal-overlay">
      <form onSubmit={handleSubmit} className="bg-igc-surface border border-igc-gold/30 max-w-md w-full p-6 relative" data-testid="convert-visitor-modal">
        <button type="button" data-testid="convert-visitor-modal-close-button" onClick={onClose} aria-label="Close" className="absolute top-4 right-4 text-igc-muted hover:text-igc-cream">
          <X size={18} />
        </button>
        <p className="font-serif text-xl text-igc-cream mb-1 pr-8">Convert to Lead</p>
        <p className="text-igc-muted text-xs mb-4">{category === "trust" ? "igchq.com (Trust)" : "irongatefunding.com (Funding)"}</p>

        <div className="space-y-3">
          <div>
            <label className="text-igc-muted text-xs uppercase tracking-widest block mb-1">Name</label>
            <input data-testid="convert-visitor-name-input" required value={name} onChange={(e) => setName(e.target.value)} className="w-full bg-igc-charcoal border border-igc-gold/15 px-3 py-2 text-sm text-igc-cream" />
          </div>
          <div>
            <label className="text-igc-muted text-xs uppercase tracking-widest block mb-1">Email</label>
            <input data-testid="convert-visitor-email-input" value={email} onChange={(e) => setEmail(e.target.value)} className="w-full bg-igc-charcoal border border-igc-gold/15 px-3 py-2 text-sm text-igc-cream" />
          </div>
          <div>
            <label className="text-igc-muted text-xs uppercase tracking-widest block mb-1">Phone</label>
            <input data-testid="convert-visitor-phone-input" value={phone} onChange={(e) => setPhone(e.target.value)} className="w-full bg-igc-charcoal border border-igc-gold/15 px-3 py-2 text-sm text-igc-cream" />
          </div>
          <div>
            <label className="text-igc-muted text-xs uppercase tracking-widest block mb-1">Assign To</label>
            <select data-testid="convert-visitor-rep-select" value={repId} onChange={(e) => setRepId(e.target.value)} className="w-full bg-igc-charcoal border border-igc-gold/15 px-3 py-2 text-sm text-igc-cream">
              <option value="">Hold Unassigned</option>
              {reps.map((r) => (
                <option key={r.id} value={r.id}>{r.display_name} ({r.user_id})</option>
              ))}
            </select>
          </div>
        </div>

        <button data-testid="convert-visitor-submit-button" disabled={saving} type="submit" className="mt-5 w-full text-sm px-4 py-2.5 bg-igc-gold text-igc-charcoal font-medium hover:bg-igc-gold/90 transition-colors disabled:opacity-50">
          {saving ? "Converting..." : "Create Lead"}
        </button>
      </form>
    </div>,
    document.body
  );
}
